import React, {
    useContext,
    useEffect, useState, useCallback
} from 'react';
import { Loader, ModalNextProvider } from '@jutro/components';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { Wizard } from 'gw-portals-wizard-react';
import SgConfirmationModalCtrl from 'sg-confirmation-modal';
import { Redirect } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import { useSgCepFlowPageReload, useSgFieldErrorHandler } from 'saga-modules';
import wizardConfig from './config/endorsement-wizard-config.json5';
import initData from './policyChangeInitData';
import wizardSkipStepsConfig from './config/endorsement-wizard-skip.config';

import messages from './SgEndorsementWizard.messages';

function SgEndorsementWizard(props) {
    const {
        history,
        location,
        match
    } = props;

    useSgCepFlowPageReload(location.pathname);
    useSgFieldErrorHandler();

    const [initialPolicyChange, setInitialPolicyChange] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    useEffect(() => {
        if (!viewModelService) {
            return;
        }
        const viewModelContext = {};
        const initialPolicyChangeData = _.clone(initData);
        if (location.state && location.state.policyNumber) {
            initialPolicyChangeData.policyNumber = location.state.policyNumber;
        }
        const initialPolicyChangeModel = viewModelService.create(
            initialPolicyChangeData,
            'pc',
            'edgev11.capabilities.policychange.dto.PolicyChangeDataDTO',
            viewModelContext
        );
        setInitialPolicyChange(initialPolicyChangeModel);
        setIsLoading(false);
    }, [viewModelService]);

    const handleCancel = useCallback(() => {
        const modalProps = {
            title: translator(messages.CancelModalHeader),
            message: translator(messages.CancelModalMessage),
            cancelBtnLabel: translator(messages.CancelModalCancelBtnLabel),
            confirmBtnLabel: translator(messages.CancelModalConfirmBtnLabel)
        };
        return ModalNextProvider.showModal(
            <SgConfirmationModalCtrl {...modalProps} />
        )
            .then()
            .catch(() => {
                history.push('/home');
            });
    }, [history, translator]);

    const handleGoBack = useCallback(() => {
        history.goBack();
    }, [history]);

    if (match && match.isExact) {
        return <Redirect to="/endorsement/entry" />;
    }

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const {
        steps,
        title
    } = wizardConfig;

    return (
        <Wizard
            initialSteps={steps}
            wizardTitle={title}
            initialData={initialPolicyChange}
            history={history}
            sgWizardPropsExt={
                {
                    handleCancel,
                    handleGoBack
                }
            }
            stepsSkipConfigExt={wizardSkipStepsConfig}
            skipCompletedSteps={false}
        />
    );
}

export default SgEndorsementWizard;
